// extracted by mini-css-extract-plugin
module.exports = {"TagBadgeArea":"TagListItem_TagBadgeArea__1IuTX","ToggleArea":"TagListItem_ToggleArea__2tGux"};